export default class Parallax {
  constructor() {
    this.container = document.querySelector('.parallax-container');
    //console.log('1');
    
    this.image = this.container
    ? this.container.querySelector('.parallax')
    : null;
    this.speed = 0.4;
    
    if (!this.container || !this.image) {
      return;
    }
    
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    
    this.init();
  }
  
  init() {
    const computedPosition = getComputedStyle(this.container).position;
    if (computedPosition === 'static') {
      this.container.style.position = 'relative';
    }
    this.container.style.overflow = this.container.style.overflow || 'hidden';
    
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    
    this.update();
  }
  
  onScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }
  
  onResize() {
    this.update();
  }
  
  update() {
    const rect = this.container.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    if (rect.bottom < 0 || rect.top > viewportHeight) {
      return;
    }
    
    const maxOffset = (this.image.offsetHeight - this.container.offsetHeight) / 2;
    
    // progress goes 0 -> 1 smoothly as the section travels from
    // just below the viewport to just above it
    const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
    let offset = (maxOffset - progress * maxOffset * 2) * 1.8;
    offset = Math.max(-maxOffset, Math.min(maxOffset, offset));
    
    this.image.style.transform = `translate3d(0, ${offset}px, 0)`;
    this.image.style.willChange = 'transform';
  }
  
  destroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }
}